import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "react-loading-skeleton";

const CountryCard = React.memo(({ name, image, navigateTo }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="col-6 col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <div className="country-card position-relative" onClick={navigateTo}>
        {isLoading && (
          <Skeleton
            height="100%"
            containerClassName="skeleton-spinner"
            duration={0.8}
          />
        )}
        <LazyLoadImage
          src={image}
          alt={name}
          className="country-image"
          onLoadStart={() => setIsLoading(true)}
          onLoad={() => setIsLoading(false)}
          style={
            isLoading ? { visibility: "hidden" } : { visibility: "visible" }
          }
        />
        <h5 className="country-name">{name}</h5>
      </div>
    </div>
  );
});

export default CountryCard;
